export default __webpack_public_path__ + "static/media/img-slider-token-4.d2d5a664.png";